import React from 'react'
import SubHeader from '../general/SubHeader'
import ContactImg from '../assets/contact-img.jpg';
import ScrollAnimation from 'react-animate-on-scroll';
import subimg9 from '../assets/contact-img.jpeg';

const Contact = () => {
  return (
    <>
      {/* <SubHeader message="Contact" /> */}
      {/* safely-measures */}
      <ScrollAnimation animateIn='fadeInUp'>
        <div className='safely-measures1'>
          <h2 >CONTACT US</h2>
          <p>"Contact KC School for admissions, events, or general queries. Our friendly team is always ready to assist, guide, <br></br>and provide the information you need to join our vibrant learning community."</p>

        </div>
      </ScrollAnimation>
      {/*end safely-measures */}


      {/* 4-cards */}
      <div className='main-section'>
        <div className='first-section'>
          <div className='image-section'>
            <img src={subimg9} alt='' />
          </div>
          <div className='description-section'>
            <ScrollAnimation animateIn='fadeInUp'>
            <h2 style={{textAlign:'center', fontWeight:'700', fontSize:'50px', color:'white'}}>Visit the School</h2>
            <p>Under Safety Measures </p>
            </ScrollAnimation>
            <ScrollAnimation animateIn='fadeInUp'>
            <h3>ADDRESS</h3>
            <p>Kamapalli Main Rd, near to Tata Benz, Chhak, Kamapalli, Brahmapur, Odisha 760004</p>
            </ScrollAnimation>
            <ScrollAnimation animateIn='fadeInUp'>
            <h3>INFORMATION</h3>
            <p>For information or questions:</p>
            </ScrollAnimation>
            <ScrollAnimation animateIn='fadeInUp'>
             <h3>E-MAIL US</h3>
            <p>kcpublicschool@gmail.com</p>
            </ScrollAnimation>
            <ScrollAnimation animateIn='fadeInUp'>
             <h3>CALL OUR MAINLINE</h3>
            <p> 0680 222 1154</p>
            </ScrollAnimation>
             <ScrollAnimation animateIn='fadeInUp'>
             <h3>OFFICE HOURS</h3>
            <p>While school is in session our staff offices are open from:</p>
            <h3>7:30 AM - 4:00 PM</h3>
            </ScrollAnimation>
          </div>
        </div>
        

        <div className='second-section'>
          <div className='description-section'>
            <ScrollAnimation className='col-lg-12 col-md-6 col-13 my-1 px-3' animateIn='fadeInLeft'>
          <h2 style={{textAlign:'center', fontWeight:'700', fontSize:'50px', color:'white'}}>Contact us Today</h2>
              <p className='fw-semibold'>Learn more about us, complete the online enquiry form.</p>

              <form className="row g-3 mt-4">
                <div className="col-lg-6">
                  <label className='input-label' style={{color:'#FF9149'}}>Your Name*</label>
                  <input type="text" className="contact-input my-2" id="inputText4" name='user_name' required />
                  <label className='input-label' style={{color:'#FF9149'}}>Your Email*</label>
                  <input type="email" className="contact-input my-2" id="inputEmail4" name='user_email' required />
                  <label className='input-label' style={{color:'#FF9149'}}>Mobile No*</label>
                  <input type="tel" className="contact-input my-2" id="inputNumber4" name='user_mobile' maxLength={10} required />
                </div>

                <div className="col-lg-6">
                  <label className='input-label' style={{color:'#FF9149'}}>Batch No (if from our School)*</label>
                  <input type="tel" className="contact-input my-2" id="inputNumber4" name='user_batch' maxLength={10} required />
                  <label className='input-label' style={{color:'#FF9149'}}>Write your Message..*</label>
                  <textarea type="text" className="contact-input my-2" id="inputAddress" name='message' style={{ height: '8.3em' }} required />
                </div>

                <div className="col-12 text-end mt-4">
                  <button type="submit" value='Send' className="carousel-btn">Submit Now</button>
                </div>
              </form>
            </ScrollAnimation>


          </div>
          <div className='image-section' style={{height:'690px'}}>
            <div className='col-lg-12 col-md-6 col-13'>
              <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d240991.64494261585!2d84.802907!3d19.304339!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3d50762c90a8df%3A0x553207ee18bf14a4!2sK%20C%20Public%20School!5e0!3m2!1sen!2sin!4v1751283988230!5m2!1sen!2sin" class="w-100"
                height="690" style={{ border: '1em solid white' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe></div>
          </div>
        </div>
      </div>
      {/*end 4-cards */}


      {/* <section className='my-4'>
        <div className='container bg-light rounded-2'>

          <div className='row'>

            <div className='col-lg-5 col-md-6 col-12'>
              <img src={ContactImg} className='img-fluid w-100 h-100' style={{ border: '1em solid white' }} />
            </div>

            <div className='col-lg-6 col-md-6 col-12 my-4'>
              <p className='about-heading'>Welcome to KC Public School</p>
              <p className='fw-semibold'>Main Campus</p>
              <p><i class="fa-solid fa-map-location-dot"></i> Kamapalli Main Rd, Near to Tata Benz, Chhak, Kamapalli, Brahmapur, Odisha 760004</p>
              <p><i class="fa-solid fa-phone"></i> Phone: 0680 222 1154</p>
              <p><i class="fa-solid fa-envelope-open-text"></i> Email: kcpublicschool@gmail.com</p>
            </div>


          </div>
          {/* row ends 

        </div>
      </section> */}


      {/* <section className='my-4'>
        <div className='container bg-light rounded-2'>

          <div className='row'>

            <div className='col-lg-5 col-md-6 col-12'>
              <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d240991.64494261585!2d84.802907!3d19.304339!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3d50762c90a8df%3A0x553207ee18bf14a4!2sK%20C%20Public%20School!5e0!3m2!1sen!2sin!4v1751283988230!5m2!1sen!2sin" class="w-100"
                height="500" style={{ border: '1em solid white' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe></div>

            <ScrollAnimation className='col-lg-7 col-md-6 col-12 my-4' animateIn='fadeInRight'>
              <p className='about-heading'>Contact us Today</p>
              <p className='fw-semibold'>Learn more about us, complete the online enquiry form.</p>

              <form className="row g-3 mt-4">
                <div className="col-lg-6">
                  <label className='input-label'>Your Name*</label>
                  <input type="text" className="contact-input my-2" id="inputText4" name='user_name' required />
                  <label className='input-label'>Your Email*</label>
                  <input type="email" className="contact-input my-2" id="inputEmail4" name='user_email' required />
                  <label className='input-label'>Mobile No*</label>
                  <input type="tel" className="contact-input my-2" id="inputNumber4" name='user_mobile' maxLength={10} required />
                </div>

                <div className="col-lg-6">
                  <label className='input-label'>Batch No (if from our School)*</label>
                  <input type="tel" className="contact-input my-2" id="inputNumber4" name='user_batch' maxLength={10} required />
                  <label className='input-label'>Write your Message..*</label>
                  <textarea type="text" className="contact-input my-2" id="inputAddress" name='message' style={{ height: '8.3em' }} required />
                </div>

                <div className="col-12 text-end mt-4">
                  <button type="submit" value='Send' className="carousel-btn">Submit Now</button>
                </div>
              </form>
            </ScrollAnimation>


          </div>
          {/* row ends 

        </div>
      </section> */}

    </>
  )
}

export default Contact
